import { actions, selectors } from '@sloyd/store-base';
import { delay, fork, put, select, takeEvery } from 'saga-ts';
import { invokeEvent } from 'shared-base';
import { createIntervalChannel } from './channels/channel.interval';
import { runCommand } from './helpers/commands';

export const saga = {
  id: 'sloyd.commands',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['commands'],
  },
};

type Verb =
  | 'success' //
  | 'error';

const map: Record<Verb, any> = {
  success: onSuccess,
  error: onError,
};

export function* onSuccess(action: any, editorCommand: IEditorCommand) {
  const { id, payload } = action;

  try {
    yield put(
      actions.editorCommands.patch(id, {
        status: 'success',
        tsEnd: Date.now(),
        isSuccess: true,
      })
    );
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* onError(action: any, editorCommand: IEditorCommand) {
  const { id, payload } = action;
  const { error } = payload;

  try {
    yield put(
      actions.editorCommands.patch(id, {
        status: 'error',
        tsEnd: Date.now(),
        errorMessage: error,
        isSuccess: false,
      })
    );
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* stepLocal(ev: any) {
  try {
    const commandsAll = yield* select(selectors.base.$editorCommands);
    const commands = commandsAll.filter((c) => c.isLocal);
    const commandsPending = commands.filter((c) => c.status === 'pending');
    const isRunning = commands.some((c) => c.status === 'running');

    if (isRunning || commandsPending.length === 0) {
      return;
    }

    const command = commandsPending[0];

    yield runCommand(command);

    yield delay(100);
  } catch (err) {}
}

export function* stepRemote(ev: any) {
  try {
    const commandsAll = yield* select(selectors.base.$editorCommands);
    const commands = commandsAll.filter((c) => !c.isLocal);
    const commandsPending = commands.filter((c) => c.status === 'pending');
    const isRunning = commands.some((c) => c.status === 'running');

    if (isRunning || commandsPending.length === 0) {
      return;
    }

    const command = commandsPending[0];
    yield runCommand(command);

    yield delay(100);
  } catch (err) {}
}

export function* step(ev: any) {
  try {
    yield stepLocal(ev);
    yield stepRemote(ev);
  } catch (err) {}
}

export function* editorCommands(action: any) {
  const { id, verb } = action;
  const editorCommand = yield* select(selectors.single.$editorCommand, id);

  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  yield* fork(saga, action, editorCommand);
}

export function* root() {
  yield takeEvery('COMMANDS', editorCommands);

  const channel = createIntervalChannel(5000);
  yield takeEvery(channel, step);
}
